/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { AddressChoiceArrayGenericResponse } from '../models/address-choice-array-generic-response';
import { CityArrayGenericResponse } from '../models/city-array-generic-response';
import { DeliveryAddressHintsRequest } from '../models/delivery-address-hints-request';
import { DeliveryAddressHintsResponseGenericResponse } from '../models/delivery-address-hints-response-generic-response';
import { DeliveryZoneForOrderRequest } from '../models/delivery-zone-for-order-request';
import { DeliveryZoneRequest } from '../models/delivery-zone-request';
import { DeliveryZoneResponseGenericResponse } from '../models/delivery-zone-response-generic-response';

@Injectable({ providedIn: 'root' })
export class AddressService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV1AddressStreetsStoreIdGet()` */
  static readonly ApiV1AddressStreetsStoreIdGetPath = '/api/v1/address/streets/{storeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AddressStreetsStoreIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1AddressStreetsStoreIdGet$Plain$Response(
    params: {
      storeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CityArrayGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, AddressService.ApiV1AddressStreetsStoreIdGetPath, 'get');
    if (params) {
      rb.path('storeId', params.storeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CityArrayGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AddressStreetsStoreIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1AddressStreetsStoreIdGet$Plain(
    params: {
      storeId: number;
    },
    context?: HttpContext
  ): Observable<CityArrayGenericResponse> {
    return this.apiV1AddressStreetsStoreIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CityArrayGenericResponse>): CityArrayGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AddressStreetsStoreIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1AddressStreetsStoreIdGet$Json$Response(
    params: {
      storeId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<CityArrayGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, AddressService.ApiV1AddressStreetsStoreIdGetPath, 'get');
    if (params) {
      rb.path('storeId', params.storeId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CityArrayGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AddressStreetsStoreIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1AddressStreetsStoreIdGet$Json(
    params: {
      storeId: number;
    },
    context?: HttpContext
  ): Observable<CityArrayGenericResponse> {
    return this.apiV1AddressStreetsStoreIdGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CityArrayGenericResponse>): CityArrayGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AddressAddressesByPostcodeGet()` */
  static readonly ApiV1AddressAddressesByPostcodeGetPath = '/api/v1/address/addresses-by-postcode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AddressAddressesByPostcodeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1AddressAddressesByPostcodeGet$Plain$Response(
    params?: {
      postCode?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AddressChoiceArrayGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, AddressService.ApiV1AddressAddressesByPostcodeGetPath, 'get');
    if (params) {
      rb.query('postCode', params.postCode, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AddressChoiceArrayGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AddressAddressesByPostcodeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1AddressAddressesByPostcodeGet$Plain(
    params?: {
      postCode?: string;
    },
    context?: HttpContext
  ): Observable<AddressChoiceArrayGenericResponse> {
    return this.apiV1AddressAddressesByPostcodeGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddressChoiceArrayGenericResponse>): AddressChoiceArrayGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AddressAddressesByPostcodeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1AddressAddressesByPostcodeGet$Json$Response(
    params?: {
      postCode?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<AddressChoiceArrayGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, AddressService.ApiV1AddressAddressesByPostcodeGetPath, 'get');
    if (params) {
      rb.query('postCode', params.postCode, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AddressChoiceArrayGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AddressAddressesByPostcodeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1AddressAddressesByPostcodeGet$Json(
    params?: {
      postCode?: string;
    },
    context?: HttpContext
  ): Observable<AddressChoiceArrayGenericResponse> {
    return this.apiV1AddressAddressesByPostcodeGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddressChoiceArrayGenericResponse>): AddressChoiceArrayGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AddressGetDeliveryZoneForOrderPost()` */
  static readonly ApiV1AddressGetDeliveryZoneForOrderPostPath = '/api/v1/address/get-delivery-zone-for-order';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AddressGetDeliveryZoneForOrderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressGetDeliveryZoneForOrderPost$Plain$Response(
    params?: {
      body?: DeliveryZoneForOrderRequest
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DeliveryZoneResponseGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, AddressService.ApiV1AddressGetDeliveryZoneForOrderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeliveryZoneResponseGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AddressGetDeliveryZoneForOrderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressGetDeliveryZoneForOrderPost$Plain(
    params?: {
      body?: DeliveryZoneForOrderRequest
    },
    context?: HttpContext
  ): Observable<DeliveryZoneResponseGenericResponse> {
    return this.apiV1AddressGetDeliveryZoneForOrderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeliveryZoneResponseGenericResponse>): DeliveryZoneResponseGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AddressGetDeliveryZoneForOrderPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressGetDeliveryZoneForOrderPost$Json$Response(
    params?: {
      body?: DeliveryZoneForOrderRequest
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DeliveryZoneResponseGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, AddressService.ApiV1AddressGetDeliveryZoneForOrderPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeliveryZoneResponseGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AddressGetDeliveryZoneForOrderPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressGetDeliveryZoneForOrderPost$Json(
    params?: {
      body?: DeliveryZoneForOrderRequest
    },
    context?: HttpContext
  ): Observable<DeliveryZoneResponseGenericResponse> {
    return this.apiV1AddressGetDeliveryZoneForOrderPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeliveryZoneResponseGenericResponse>): DeliveryZoneResponseGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AddressGetDeliveryZonePost()` */
  static readonly ApiV1AddressGetDeliveryZonePostPath = '/api/v1/address/get-delivery-zone';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AddressGetDeliveryZonePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressGetDeliveryZonePost$Plain$Response(
    params?: {
      body?: DeliveryZoneRequest
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DeliveryZoneResponseGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, AddressService.ApiV1AddressGetDeliveryZonePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeliveryZoneResponseGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AddressGetDeliveryZonePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressGetDeliveryZonePost$Plain(
    params?: {
      body?: DeliveryZoneRequest
    },
    context?: HttpContext
  ): Observable<DeliveryZoneResponseGenericResponse> {
    return this.apiV1AddressGetDeliveryZonePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeliveryZoneResponseGenericResponse>): DeliveryZoneResponseGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AddressGetDeliveryZonePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressGetDeliveryZonePost$Json$Response(
    params?: {
      body?: DeliveryZoneRequest
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DeliveryZoneResponseGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, AddressService.ApiV1AddressGetDeliveryZonePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeliveryZoneResponseGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AddressGetDeliveryZonePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressGetDeliveryZonePost$Json(
    params?: {
      body?: DeliveryZoneRequest
    },
    context?: HttpContext
  ): Observable<DeliveryZoneResponseGenericResponse> {
    return this.apiV1AddressGetDeliveryZonePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeliveryZoneResponseGenericResponse>): DeliveryZoneResponseGenericResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AddressHintsPost()` */
  static readonly ApiV1AddressHintsPostPath = '/api/v1/address/hints';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AddressHintsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressHintsPost$Plain$Response(
    params?: {
      body?: DeliveryAddressHintsRequest
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DeliveryAddressHintsResponseGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, AddressService.ApiV1AddressHintsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/plain', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeliveryAddressHintsResponseGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AddressHintsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressHintsPost$Plain(
    params?: {
      body?: DeliveryAddressHintsRequest
    },
    context?: HttpContext
  ): Observable<DeliveryAddressHintsResponseGenericResponse> {
    return this.apiV1AddressHintsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeliveryAddressHintsResponseGenericResponse>): DeliveryAddressHintsResponseGenericResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AddressHintsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressHintsPost$Json$Response(
    params?: {
      body?: DeliveryAddressHintsRequest
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<DeliveryAddressHintsResponseGenericResponse>> {
    const rb = new RequestBuilder(this.rootUrl, AddressService.ApiV1AddressHintsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'text/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DeliveryAddressHintsResponseGenericResponse>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AddressHintsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiV1AddressHintsPost$Json(
    params?: {
      body?: DeliveryAddressHintsRequest
    },
    context?: HttpContext
  ): Observable<DeliveryAddressHintsResponseGenericResponse> {
    return this.apiV1AddressHintsPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeliveryAddressHintsResponseGenericResponse>): DeliveryAddressHintsResponseGenericResponse => r.body)
    );
  }

}
